import { useMemo } from 'react';

import addEventToDataLayer from 'components/Integration/addEventToDataLayer';
import IngressinhoCarnaval from 'assets/imgs/ingressinho-massacote-todos.svg';
import Button from '@sympla/sympla-components/Button';
import { IconWhatsapp } from '@sympla/sympla-components';
import remoteConfigDiscovery from 'json/RemoteConfig.json';
import { RemoteConfig } from 'RemoteConfig';
import { isMobile } from 'utils/misc';

import * as styles from './BannerTimer.css';

function BannerTimer({ matrixSlug, label }: { matrixSlug: string; label: string }) {
  const infoBanner = (remoteConfigDiscovery as RemoteConfig).discovery?.[matrixSlug]?.timerCollection;
  const date = useMemo(() => {
    if (!infoBanner?.endDate) return 0;
    const todayDate = Date.now();
    const nextDate = new Date(infoBanner?.endDate).getTime();
    const diffTime = nextDate - todayDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }, [infoBanner?.endDate]);

  const dateText = `${date} dia${date === 1 ? '' : 's'}`;
  const labelText = ` para o ${label}`;

  if (date <= 0) return null;

  const handleShareClick = () => {
    addEventToDataLayer({
      category: 'consumerInteraction',
      label: `.jorney-discovery.step-event_collection-${matrixSlug}.compartilhar`,
      action: 'share',
    });

    const params = window.location.search.includes('utm_source')
      ? ''
      : `share_id=whatsapp&utm_source=contador_sazonal&utm_campaign=colecao_${matrixSlug}`;
    const eventUrl = encodeURIComponent(`${window.location.href}${window.location.search ? '&' : '?'}${params}`);

    const text = `${infoBanner?.textWhatsapp?.replace('{dateText}', dateText)} \n ${eventUrl}`;
    const typeWhatsapp = isMobile() ? 'api' : 'web';
    window.open(`https://${typeWhatsapp}.whatsapp.com/send?text=${text}`);
  };

  return (
    <div className={styles.BannerContainer}>
      <IngressinhoCarnaval className={styles.BannerImage} />
      <div className={styles.BannerContainerText}>
        <p className={styles.BannerTextSmall}>{date === 1 ? 'FALTA' : 'FALTAM'}</p>
        <p className={styles.BannerTextDate}>
          <strong>{dateText}</strong>
          {labelText}
        </p>
      </div>

      <div className={styles.BannerContent}>
        <p className={styles.BannerText}>Os ingressos estão voando! Corra e não fique de fora!</p>
        <Button fullWidthOnMobile onClick={handleShareClick} upperCase={false} size="small" aria-label="Compartilhe agora">
          <IconWhatsapp className={styles.BannerIcon} width={14} height={14} />
          Compartilhe agora
        </Button>
      </div>
    </div>
  );
}

export default BannerTimer;
